export default `float de(vec3 p){
    float angle = 1.; 
    float ra = 1.; 

    vec2 c = vec2(sin(angle),cos(angle));
    vec2 p0 = vec2( length(p.xz), p.y );
    float l = length(p0) - ra;
    float m = length(p0 - c*clamp(dot(p0,c),0.0,ra) );
    return max(l,m*sign(c.y*p0.x-c.x*p0.y));
  }`